module.exports = __webpack_public_path__ + "static/img/logo.332af493.svg";